// CTASection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ConsultationModal from '../ConsultationModal';

const CTASection = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <section className="py-20 bg-[#202356]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6">
            Start Your Study Abroad Journey with Confidence
          </h2>
          
          <p className="text-gray-300 text-base md:text-lg font-light leading-relaxed mb-10 max-w-2xl mx-auto">
            Book a free consultation to explore your options, understand available opportunities, and receive clear guidance on your next steps.
          </p>
          
          <button
            onClick={() => setShowConsultationModal(true)}
            className="inline-flex items-center gap-3 bg-white hover:bg-gray-100 text-[#202356] font-normal text-base px-10 py-4 rounded-lg transition-colors"
          >
            Book a Free Consultation
            <ArrowRight size={20} />
          </button>
        </motion.div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="study-abroad"
      />
    </section>
  );
};

export default CTASection;
